import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import camelcaseKeys from 'camelcase-keys'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faSms, faTachometerAlt, faTasks } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

import reserveApi from '../../../utils/axios'

import { AdminHeader } from '../Index'
import { AdminTd, AdminTh, AdminTable } from '../Tables'
import DateFormat from '../../utils/dateFormat'

const typeIcons = {
  email: faEnvelope,
  sms: faSms,
  web: faGlobe
}

export const AvailabilityNotifications = ({ short, userId = null }) => {
  const [availabilityNotifications, setAvailabilityNotifications] = useState([])

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/admin/availability_notifications',
      params: { user_id: userId }
    }).then(response => {
      setAvailabilityNotifications(camelcaseKeys(response.data, { deep: true }))
    })
  }, [userId])

  return (
    <div>
      {!short && <AdminHeader>AvailabilityRequestMatches</AdminHeader>}

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>X</AdminTh>
            <AdminTh>Param</AdminTh>
            <AdminTh>UserId</AdminTh>
            <AdminTh>Request</AdminTh>
            <AdminTh>Facility</AdminTh>
            <AdminTh>Created</AdminTh>
          </tr>
        </thead>
        {availabilityNotifications.map((obj, index) => (
          <tr key={index} className={obj.id && index % 2 !== 0 && 'bg-green-100'}>
            <AdminTd>
              <FontAwesomeIcon icon={typeIcons[obj.notificationMethod?.notificationType]} className="" />
              {obj.throttled && <FontAwesomeIcon icon={faTachometerAlt} className="ml-1" />}
              {obj.recentlyNotified && <FontAwesomeIcon icon={faTasks} className="ml-1" />}
            </AdminTd>

            <AdminTd>{obj.notificationMethod?.param}</AdminTd>
            <AdminTd>
              <Link to={`/admin/users/${obj.notificationMethod?.userId}`}>{obj.notificationMethod?.userId}</Link>
            </AdminTd>
            <AdminTd>{obj.availabilityRequestId}</AdminTd>
            <AdminTd>{obj.facilityName}</AdminTd>
            <AdminTd>
              <DateFormat date={obj.createdAt} format="l LTS" />
            </AdminTd>
          </tr>
        ))}
      </AdminTable>
    </div>
  )
}

export default AvailabilityNotifications
